import type { FaireProductEntity } from "../../entity_types/product";

export const p_7qzg4mc6pc: FaireProductEntity = {
  token: "p_7qzg4mc6pc",
  type: "product",
  name: "Flint Stainless Steel Flatware Place Setting s/5",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/4d86911c20d1ceebe889af914be4b1fe063cfeba5c58567bdd2ae9bea8983477.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c6c9e9ab6547b24c340185c29ca5db4bad8b21bce802208d08b5e35a3bf3f5ea.jpeg",
    "https://cdn.faire.com/fastly/abd83f681add8960ea8835e4c5e902dd807adf1dd8e43e5b59798979075359bd.jpeg",
    "https://cdn.faire.com/fastly/0d6b504a57600fb04972a47525c7dec9ac6050ffd15627f8ef34b27dcba53472.jpeg",
  ],
  priceDollars: 22.5,
  description:
    "FLINT is a modern cutlery range which has been meticulously designed with a great deal of care and passion over several years striving for perfection! Well-weighted and minimal in style, the soft forms make the range tactile and a pleasure to use. The gentle radius to the underside of the handle allows each item to sit comfortably in the hand.\n\nMaterial: 18/10 Brushed Stainless Steel",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:27.420Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
